// src/design-system/components/PlanCard.jsx
import React from 'react';
import EnergyButton from './EnergyButton';
import PurpleButton from './PurpleButton';
import SecondaryButton from './SecondaryButton';
import { CheckIcon } from '@heroicons/react/24/outline';

/**
 * PlanCard — Card branco gelo com texto escuro.
 * Featured usa PurpleButton, demais usam SecondaryButton.
 * CTA de pagamento usa EnergyButton.
 *
 * @param {string}  name       - Nome do plano
 * @param {string}  price      - Preço formatado (ex: "R$ 49")
 * @param {string}  period     - Período (ex: "/mês")
 * @param {Array}   features   - Lista de features (strings)
 * @param {boolean} featured   - Destaque (borda roxa + glow)
 * @param {string}  badge      - Texto do badge (ex: "Mais Popular")
 * @param {string}  ctaText    - Texto do botão CTA
 * @param {func}    onCta      - Callback do botão
 * @param {boolean} energy     - Força EnergyButton no CTA
 */
export default function PlanCard({
  name,
  price,
  period = '/mês',
  features = [],
  featured = false,
  badge,
  ctaText = 'Assinar',
  onCta,
  energy = false,
  className = '',
}) {
  // Featured plan → PurpleButton; energy prop → EnergyButton; else SecondaryButton
  let Btn = SecondaryButton;
  if (energy) Btn = EnergyButton;
  else if (featured) Btn = PurpleButton;

  return (
    <div className={`ds-plan-card ${featured ? 'ds-plan-card--featured' : ''} ${className}`}>
      {badge && <span className="ds-plan-card__badge">{badge}</span>}
      <h3 className="ds-plan-card__name">{name}</h3>
      <div className="ds-plan-card__price">
        {price}
        <small>{period}</small>
      </div>
      {features.length > 0 && (
        <ul className="ds-plan-card__features">
          {features.map((f, i) => (
            <li key={i}>
              <CheckIcon style={{ width: 16, height: 16 }} />
              {f}
            </li>
          ))}
        </ul>
      )}
      <div className="ds-plan-card__cta">
        <Btn fullWidth onClick={onCta}>{ctaText}</Btn>
      </div>
    </div>
  );
}
